import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import LiveViewers from "../LiveViewers";

export function CategoryHeader({ searchQ, currentCat, loading, products, total, slug, breadcrumb }) {
    return (
        <>
            <div className="bg-white rounded-2xl border border-gray-200/80 p-3 sm:p-4 mb-5 shadow-sm" data-testid="category-header-frame">
                <div className="flex items-center flex-wrap gap-x-4 gap-y-1" data-testid="category-header-row">
                    <h1 className="text-3xl sm:text-4xl font-heading font-black text-gray-900 tracking-tight" data-testid="category-title">
                        {searchQ ? `Výsledky pro "${searchQ}"` : currentCat?.name || "Všechny produkty"}
                    </h1>
                    <span className="text-sm text-gray-400 font-medium" data-testid="product-count">
                        {loading && !products.length ? "" : `${total.toLocaleString("cs-CZ")} produktů`}
                    </span>
                    {slug && <LiveViewers type="category" slug={slug} />}
                    <nav className="flex items-center gap-1.5 text-sm" aria-label="Breadcrumb" data-testid="breadcrumb">
                        <Link to="/" className="text-gray-400 hover:text-green-700 transition-colors font-medium">Domů</Link>
                        {!slug && <><ChevronRight size={11} className="text-gray-300" /><span className="text-gray-600 font-semibold">Katalog</span></>}
                        {breadcrumb.map((item, i) => (
                            <React.Fragment key={item.id}>
                                <ChevronRight size={11} className="text-gray-300" />
                                {i < breadcrumb.length - 1
                                    ? <Link to={`/kategorie/${item.slug}`} className="text-gray-400 hover:text-green-700 transition-colors font-medium">{item.name}</Link>
                                    : <span className="text-gray-600 font-semibold">{item.name}</span>}
                            </React.Fragment>
                        ))}
                        {searchQ && <><ChevronRight size={11} className="text-gray-300" /><span className="text-gray-500">"{searchQ}"</span></>}
                    </nav>
                </div>
            </div>
            {currentCat?.description && (
                <p className="text-gray-500 text-sm max-w-2xl mx-auto text-center leading-relaxed mb-4">{currentCat.description}</p>
            )}
        </>
    );
}
